export default "__VITE_ASSET__DkWziIr8__"